import { render } from "./LogoWCopySvg.vue?vue&type=template&id=07a6ceec"
import script from "./LogoWCopySvg.vue?vue&type=script&lang=js"
export * from "./LogoWCopySvg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__